module.exports = __webpack_public_path__ + "b60ace7f0a14f6b5e6f26d6c9b98ee83.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-16.png
// module id = 3092
// module chunks = 0